module.exports = __webpack_public_path__ + "img/normal.cf07cd0b.svg";